import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { HttpService } from '@services/http.service';
import { EndpointParams } from '@models/utils/endpoint-params';
import { CouponCodeInfo } from '@models/coupon/coupon-code-info';

@Injectable({
    providedIn: 'root'
})
export class CouponService extends HttpService {
    private readonly defaultEndpointParams: EndpointParams = { app: 'payments', version: 1 };

    apply(code: string, idFees: string[]): Observable<CouponCodeInfo> {
        return this.post('coupons/members/code/apply', this.defaultEndpointParams, { code, idFees });
    }
}
